module.exports = __webpack_public_path__ + "img/shovel-snow.e6bd08c9.svg";